import type { ReactElement } from 'react';

interface Props {
  score: number;
  reasons?: string[];
}

/**
 * Compact chip showing no-show risk score with a tooltip listing reasons.
 * Color thresholds: <30 = green, 30-60 = amber, >60 = red.
 */
export function NoShowBadge({ score, reasons = [] }: Props): ReactElement {
  const tone = score >= 60 ? 'red' : score >= 30 ? 'amber' : 'emerald';
  const colorClass =
    tone === 'red'
      ? 'bg-red-50 text-red-700 border-red-200'
      : tone === 'amber'
        ? 'bg-amber-50 text-amber-700 border-amber-200'
        : 'bg-emerald-50 text-emerald-700 border-emerald-200';
  return (
    <span
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-xs font-medium ${colorClass}`}
      title={reasons.join('\n')}
    >
      No-show risk <span className="num ml-1">{score}</span>
    </span>
  );
}
